import {filter, map} from 'rxjs';

import {inject, Injectable, Signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {NavigationEnd, Router} from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class RouteHistoryService {
	private static readonly ROUTE_HISTORY_LOCAL_STORAGE_KEY: string = 'ROUTE_HISTORY';
	private static readonly MAX_ROUTE_HISTORY_LENGTH: number = 10;
	/* -------------------------------------------------------------------------------------------------------------- */
	private readonly router: Router = inject(Router);

	/* -------------------------------------------------------------------------------------------------------------- */
	public readonly currentRoute$: Signal<string> = toSignal(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(map(() => this.router.url)));

	constructor() {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.saveRouteHistory());
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	public getLatestNthRoutes(n: number): string[] {
		const routeHistory: string[] = this.getRouteHistory();
		return routeHistory.slice(-n);
	}

	public getRouteHistory(): string[] {
		return JSON.parse(sessionStorage.getItem(RouteHistoryService.ROUTE_HISTORY_LOCAL_STORAGE_KEY)) || [];
	}

	public saveRouteHistory(): void {
		const routeHistory: string[] = this.getRouteHistory();
		const currentRoute: string = this.router.url;
		if (routeHistory[routeHistory.length - 1] !== currentRoute) {
			routeHistory.push(currentRoute);
		}
		if (routeHistory.length > RouteHistoryService.MAX_ROUTE_HISTORY_LENGTH) {
			routeHistory.shift();
		}
		sessionStorage.setItem(RouteHistoryService.ROUTE_HISTORY_LOCAL_STORAGE_KEY, JSON.stringify(routeHistory));
	}

	public clearRouteHistory(): void {
		sessionStorage.removeItem(RouteHistoryService.ROUTE_HISTORY_LOCAL_STORAGE_KEY);
	}
}
